<div class="text-image-container">
  <Components.Text className="text-side" fields={{ text: fields.text }} />
  <div class="image-side">
    {#if fields.image.src}
      <Components.LazyImg
        src={fields.image.src}
        alt={fields.image.alt || 'Text image pair'}
        title={fields.image.title}
        url={fields.image.url}
      />
    {:else}
      <p>No image selected</p>
    {/if}
  </div>
</div>

<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};
  export const Components = {
    load: [
      'core/extensions/lazy_img/v1.0.0/LazyImg',
      'legacy/plugins/text/v1.0.0/Text',
    ],
  }

  export const classNames = ['plugin__text-image']
</script>

<script>
  export let fields = {}

  $: if (!fields.text) {
    fields.text = [{ data: '<p>Click here to edit this text.</p>', type: 'html' }]
  }

  $: if (!fields.image) {
    fields.image = {
      src: null,
      alt: null,
      title: null,
      url: null,
    }
  }
</script>
